var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.995 5.953L3.995.5 10.987.5 10.987 5.937M3.995 18.063L3.995 23.5 10.987 23.5 10.987 18.032",
    transform: "translate(-174 -166) translate(161 153) translate(13.016 13) translate(4.994 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M14.483 12c0 3.867-3.132 7-6.992 7-3.862 0-6.992-3.133-6.992-7 0-3.866 3.13-7 6.992-7 3.86 0 6.992 3.134 6.992 7z",
    transform: "translate(-174 -166) translate(161 153) translate(13.016 13) translate(4.994 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M6.992 9L6.992 12 10.487 15",
    transform: "translate(-174 -166) translate(161 153) translate(13.016 13) translate(4.994 .5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.65fa212a.svg";
export { ForwardRef as ReactComponent };